import React from 'react';

interface ProfileImageSectionProps {
    nickname: string;
    email: string;
    avatarUrl?: string;
    onChangeImage?: () => void;
}

export const ProfileImageSection: React.FC<ProfileImageSectionProps> = ({
    nickname,
    email,
    avatarUrl,
    onChangeImage
}) => {
    return (
        <>
            <div className="profile-image-section">
                <div className="profile-image">
                    {avatarUrl ? (
                        <img src={avatarUrl} alt={nickname} />
                    ) : (
                        <span className="profile-avatar">👤</span>
                    )}
                </div>
                {onChangeImage && (
                    <button className="change-image-button" onClick={onChangeImage}>
                        📷
                    </button>
                )}
            </div>

            <div className="profile-info">
                <div className="profile-user-id">
                    <span className="user-name">{nickname}</span>
                    <span className="user-email">{email}</span>
                </div>
            </div>
        </>
    );
};
